import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/dialog_header_icon.png",
  alt: ""
}, null, -1)
const _hoisted_3 = { class: "divider" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "content" }, " 一部商品が出荷待ち状態です。分割出荷が必要となる可能性がありますので、出荷倉庫を変更するかご確認ください。 ", -1)
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("確定")

import { ref, computed } from 'vue'
import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  emits: ['success'],
  setup(__props, { expose, emit: emits }) {

const dialogVisible = ref(false)


const open = () => {
  dialogVisible.value = true
}
const closeModal = () => {
  dialogVisible.value = false
}

const handleSure = () => {
  emits('success')
  closeModal()
}

expose({
  open
})


return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
    width: "400px",
    "custom-class": "ReplaceWareConfirm",
    "close-on-click-modal": false,
    onClose: closeModal
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", null, _toDisplayString(_unref(t)('温馨提示')), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_component_el_button, {
          color: "#000",
          round: "",
          type: "primary",
          onClick: handleSure
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_divider, { style: {"margin":"0"} })
      ]),
      _hoisted_4
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})